import { formatDateOnly, parseJsonArray, parseJsonObject, parseReportMediaArray, CAR_ROW_STATUS_OPTIONS } from './carReportUtils';

export { formatDateOnly, CAR_ROW_STATUS_OPTIONS as EIGHT_D_ROW_STATUS_OPTIONS };

export const EIGHT_D_ORIGIN_OPTIONS = [
    'Customer Complaint',
    'Internal Audit',
    'External Audit',
    'Scrap/Defect',
];

export const DEFAULT_D4_WHYS = {
    why1: '',
    why2: '',
    why3: '',
    why4: '',
    why5: '',
};

export function emptyD1TeamRow() {
    return { role: '', name: '', department: '', contactEmail: '' };
}

export function emptyD3ContainmentRow() {
    return {
        actionDescription: '',
        owner: '',
        targetDate: '',
        implDate: '',
        effectivenessPct: '',
        status: 'Open',
    };
}

export function emptyD6PcaRow() {
    return {
        pcaActionItem: '',
        owner: '',
        targetDate: '',
        validationDate: '',
        validationMethodResult: '',
        validationPhotos: [],
    };
}

export { imageUrlFromPath, normalizeReportMediaItem, parseReportMediaArray, mapUploadedImageFiles } from './carReportUtils';

export function normalizeD1Rows(raw) {
    const rows = parseJsonArray(raw);
    if (!rows.length) return [emptyD1TeamRow()];
    return rows.map((r) => ({
        role: r.role || '',
        name: r.name || '',
        department: r.department || '',
        contactEmail: r.contactEmail || '',
    }));
}

export function normalizeD3Rows(raw) {
    if (typeof raw === 'string' && raw.trim() && !raw.trim().startsWith('[')) {
        return [{ ...emptyD3ContainmentRow(), actionDescription: raw.trim() }];
    }
    const rows = parseJsonArray(raw);
    if (!rows.length) return [emptyD3ContainmentRow()];
    return rows.map((r) => ({
        actionDescription: r.actionDescription || r.actionTaken || '',
        owner: r.owner || '',
        targetDate: formatDateOnly(r.targetDate),
        implDate: formatDateOnly(r.implDate || r.dateCompleted),
        effectivenessPct: r.effectivenessPct || '',
        status: r.status || 'Open',
    }));
}

export function normalizeD6Rows(raw) {
    const rows = parseJsonArray(raw);
    if (!rows.length) return [emptyD6PcaRow()];
    return rows.map((r) => ({
        pcaActionItem: r.pcaActionItem || r.actionDescription || '',
        owner: r.owner || '',
        targetDate: formatDateOnly(r.targetDate),
        validationDate: formatDateOnly(r.validationDate),
        validationMethodResult: r.validationMethodResult || '',
        validationPhotos: parseReportMediaArray(r.validationPhotos),
    }));
}

export function latestDateFromRows(rows, field) {
    let latest = '';
    (rows || []).forEach((row) => {
        const d = formatDateOnly(row[field]);
        if (d && (!latest || d > latest)) latest = d;
    });
    return latest;
}

export function parseD4Whys(raw, legacyText) {
    const obj = parseJsonObject(raw, DEFAULT_D4_WHYS);
    if (!obj.why1 && legacyText) {
        return { ...DEFAULT_D4_WHYS, why1: legacyText };
    }
    return obj;
}
